import React, { forwardRef, useCallback } from 'react';
import noop from 'lodash/noop';
const TabBarInner = forwardRef(function TabBarInner(props, ref) {
    const { onTabClick = noop, tabKey, ...rest } = props;
    const handleClick = useCallback(() => onTabClick(tabKey), [onTabClick, tabKey]);
    return (React.createElement("div", Object.assign({}, rest, { onClick: handleClick, ref: ref })));
});
TabBarInner.displayName = 'TabBarInner';
export default TabBarInner;
